import {
    MeetingCreateModel,
    MeetingDeleteApiV1AdjutantAppMeetingMeetingIdDeleteParams,
    MeetingDeleteOutputDTO,
    MeetingDTO,
    MeetingListApiV1AdjutantAppMeetingGetParams,
    MeetingListOutputDTO,
    MeetingStopRecordingApiV1AdjutantAppMeetingMeetingIdStopRecordingPostParams,
    MeetingUpdateApiV1AdjutantAppMeetingMeetingIdPutParams,
    MeetingUpdateModel,
} from '../swagger/dto'
import { deleteRequest, getRequest, postRequest, putRequest } from './config'
import { MEET_URL } from './endpoints.constants'

export const createMeet = async (data: MeetingCreateModel) => {
    const response = await postRequest<MeetingCreateModel, MeetingDTO>(MEET_URL, data)
    return response.data
}

export const updateMeet = async (
    params: MeetingUpdateApiV1AdjutantAppMeetingMeetingIdPutParams,
    payload: MeetingUpdateModel,
) => {
    const response = await putRequest<MeetingDTO>(`${MEET_URL}/${params.meetingId}`, payload)
    return response.data
}

export const stopRecordingMeet = async (
    params: MeetingStopRecordingApiV1AdjutantAppMeetingMeetingIdStopRecordingPostParams,
) => {
    const response = await postRequest<MeetingStopRecordingApiV1AdjutantAppMeetingMeetingIdStopRecordingPostParams, MeetingDTO>(
        `${MEET_URL}/${params.meetingId}/stop_recording`,
        params,
    )
    return response.data
}

export const removeMeet = async (
    params: MeetingDeleteApiV1AdjutantAppMeetingMeetingIdDeleteParams,
) => {
    const response = await deleteRequest<MeetingDeleteOutputDTO>(`${MEET_URL}/${params.meetingId}`)
    return response.data
}

export const getMeet = async (params: MeetingListApiV1AdjutantAppMeetingGetParams) => {
    const response = await getRequest<MeetingListOutputDTO>(MEET_URL, params)
    return response.data
}
